import React, { useContext } from "react";
import "./Life_at_Ambassadeur.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import Common_subHeading from "../../common_components/common_subHeading/Common_subHeading";
import { Context } from "../../../utils/context";

function Life_at_Ambassadeur() {

  const {language} = useContext(Context);
  
  const lifeImages = [
    "/assets/images/study_abroad/life_at_Ambassadeur/img_1.webp",
    "/assets/images/study_abroad/life_at_Ambassadeur/img_2.webp",
    "/assets/images/study_abroad/life_at_Ambassadeur/img_3.webp",
    "/assets/images/study_abroad/life_at_Ambassadeur/img_4.webp",
    "/assets/images/study_abroad/life_at_Ambassadeur/img_5.webp",
    "/assets/images/study_abroad/life_at_Ambassadeur/img_6.webp",
  ];

  return (
    <>
      <section className="Life_at_Ambassadeur">
        <div className="container">
          {/* <Common_subHeading subHeading="Life at AFI" /> */}

          <Common_subHeading 
  subHeading={
    language == 1 
      ? "Life at AFI" 
      : "La vie chez AFI"
  } 
/>

          <div className="slider_holder">
            <Swiper
              pagination={{ clickable: true }}
              modules={[Pagination]}
              slidesPerView={4}
              spaceBetween={10}
              className="Luxury_Hospitality_mySwiper common_swiper"
              breakpoints={{
                0: {
                  // Mobile
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                576: {
                  // Small devices
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                768: {
                  // Tablets
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                992: {
                  // Laptop
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1200: {
                  // Large screens
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
              }}
            >
              {lifeImages.map((src, index) => (
                <SwiperSlide key={index}>
                  <div className="img_holder">
                    <img
                      className="Life_at_Ambassadeur_img"
                      src={src}
                      alt={`life ambassadeur ${index + 1}`}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Life_at_Ambassadeur;
